// extracted by mini-css-extract-plugin
module.exports = {"inputHolder":"InputText_inputHolder__3njbz","placeholder":"InputText_placeholder__31FVL","active":"InputText_active__3egOB","icon":"InputText_icon__liT0r"};